import apiServices from '../../ApiServices/request-handler';
import { downloadBase64File, requestHandler } from '../../utils/functions';
import { setAccountOpeingFormLoading, setAccountOpeningLoading, setApplicationDropdown, setApplicationTypeDropdownLoading, setNafathLoading, setSendOtpLoading, setVerifyOtpLoading } from '../slices/accountOpeningSlice';
import { setCorporateDropdownData, setCorporateKycData, setCorporateLoading, setCorporateSaveLoading, setDeleteDraftKycLoading, setFieldCodes, setFieldCodesLoading, setIsRejected, setRejectionSummary, setUploadLoading } from '../slices/corporate-slice';
import { setAccountOpening } from '../slices/contentSlice';
import { setCommonLoading } from '../slices/commonSlice';


export const createAccount = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                setLoading: setAccountOpeningLoading,
                param_data: data,
                apiService: apiServices.createBlankApplication,
                isSuccessMessage: true,
                setData: setAccountOpening,
                onDone: (val) => {
                    onDone && onDone()
                }
            })
        );
    };
};

export const generateAccountOtp = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                setLoading: setSendOtpLoading,
                param_data: data,
                apiService: apiServices.generateAccountOtp,
                isSuccessMessage: true,
                onDone: () => {
                    onDone && onDone()
                }
            })
        )
    }
}

export const verifyAccountOtp = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.verifyAccountOtp,
                param_data: data,
                setLoading: setVerifyOtpLoading,
                isSuccessMessage: true,
                isErrorMessage: true,
                onDone: (res) => {
                    onDone && onDone(res)
                }
            })
        )
    }
}

export const getApplicationTypes = (id) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.getApplicationTypeDropdown,
                param_data: id,
                setLoading: setApplicationTypeDropdownLoading,
                setData: setApplicationDropdown,
            })
        )
    }
}

export const getAccountOpeningForm = (id, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices?.getAccountOpeningForm,
                param_data: id,
                setLoading: setAccountOpeingFormLoading,
                setData: setCorporateKycData,
                onDone: (val) => {
                    onDone && onDone(val)
                }
            })
        )
    }

}

// getAccountOpeningDropdowns
export const getAccounOpeningDropdowns = (id) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices?.getAccountOpeningDropdowns,
                param_data: id,
                setData: setCorporateDropdownData
            })
        )
    }
}

// saveAccountOpeningData
export const saveAccountOpeningData = (data, onDone) => {

    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.saveAccountOpeningData,
                param_data: data,
                setLoading: setCorporateSaveLoading,
                onDone: (data) => onDone?.(),
                isSuccessMessage: true,
            }),
        );
    };
};

export const submitAccountopeningData = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.submitAccountOpeningData,
                param_data: data,
                setLoading: setCorporateSaveLoading,
                onDone: (data) => onDone?.(),
                isSuccessMessage: true
            })
        )
    }
}

//  upload document
export const uploadAccountOpeningDocument = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.uploadCorporateClientDocuments,
                param_data: data,
                setLoading: setCorporateLoading,
                onDone: (data) => {
                    onDone?.();
                },
                isSuccessMessage: true,
            }),
        );
    };
};

export const deleteAccountOpeningDocument = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.deleteAccountOpeningDocument,
                param_data: data,
                setLoading: setCorporateLoading,
                onDone: (data) => {
                    onDone?.();
                },
                isSuccessMessage: true,
            }),
        );
    };
};

export const downloadAccountOpeningDocument = (data, onDone) => {

    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.downloadAccountOpeningDocument,
                param_data: data,
                setLoading: setCorporateLoading,
                onDone: async (response) => {
                    downloadBase64File({ base64Data: response?.result?.payload, fileName: response?.result?.fileName, type: response?.result?.mimeType });
                },
                isSuccessMessage: true,
            }),
        );
    };
};

export const saveAccountOperation = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.saveAccountOperation,
                param_data: data,
                setLoading: setCorporateSaveLoading,
                onDone: (val) => {
                    onDone && onDone()
                },
                isSuccessMessage: true,
            }),
        );
    };
}

export const getAccountOpeningRejectionSummary = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.getAccountOpeningRejectionSummary,
                param_data: data,
                setData: setRejectionSummary,
                onDone: async (response) => {
                    response?.result?.length > 0 ?
                        dispatch(setIsRejected(true)) :
                        dispatch(setIsRejected(false));
                    onDone?.(response);
                },
                onError: (error) => {
                    dispatch(setIsRejected(false));
                    dispatch(setRejectionSummary(null));
                },
                isErrorMessage: false,
            }),
        );
    };
};

export const getAccountOpeningFieldCodes = (id, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.getAccountOpeningFieldCodes,
                setData: setFieldCodes,
                data: id,
                setLoading: setFieldCodesLoading,
                onDone: async (response) => {
                    onDone?.();
                },
                isSuccessMessage: false,
            }),
        );
    };
};

export const deleteAccountOpeningDraft = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.deleteAccountOpeningDraftKyc,
                param_data: data,
                setData: setAccountOpening,
                setLoading: setDeleteDraftKycLoading,
                onDone: async (response) => {
                    onDone?.(response);
                },
            }),
        );
    };
}
export const validateAccountOpeningIban = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.validateAccountOpeningIban,
                param_data: data,
                setLoading: setCorporateLoading,
                onDone: async (response) => {
                    onDone?.(response);
                },
                isErrorMessage: true,
            }),
        );
    };
};

export const fetchAccountOpeningDocument = (id, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.fetchAccountOpeningDocument,
                param_data: id,
                setLoading: setUploadLoading,
                onDone: async (response) => {
                    onDone?.(response);
                },
            }),
        );
    };
}

export const nafathVerification = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.nafathVerification,
                param_data: data,
                setLoading: setNafathLoading,
                onDone: async (response) => {
                    onDone?.(response);
                },
            }),
        );
    }
}

export const getNafathStatus = (params, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.getNafathStatus,
                param_data: params,
                setLoading: setNafathLoading,
                onDone: async (response) => {
                    onDone?.(response);
                },
            }),
        );
    }
}

// documentType: 1 = Brokerage, 2 = Managed Investments
export const downloadTargetedProductTerms = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.downloadTargetedProductTerms,
                param_data: data,
                setLoading: setCommonLoading,
                onDone: async (response) => {
                    downloadBase64File({ base64Data: response?.result?.base64Content, fileName: response?.result?.fileName, type: response?.result?.contentType });
                    onDone?.(response);
                },
            }),
        );
    }
}

// documentType: 1 = Terms and Conditions, 2 = Privacy Policy
export const downloadAccountOpeningTerms = (data, onDone) => {
    return async (dispatch) => {
        dispatch(
            requestHandler({
                apiService: apiServices.downloadAccountOpeningTerms,
                param_data: data,
                setLoading: setCommonLoading,
                onDone: async (response) => {
                    downloadBase64File({ base64Data: response?.result?.base64Content, fileName: response?.result?.fileName, type: response?.result?.contentType });
                    onDone?.(response);
                },
            }),
        );
    }
}